export default __webpack_public_path__ + "static/media/453.1695ddb1.jpg";